// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 177 ? "home" : chunkId) + "." + {"177":"12ffc19f","500":"d42cd218"}[chunkId] + ".css";
};